import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { HeightDirective } from '../../../../shared/directives/height.directive';
import { WidthDirective } from '../../../../shared/directives/width.directive';

@Component({
  selector: 'ots-initial-loading',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [HeightDirective, WidthDirective],
  templateUrl: './initial-loading.component.html',
  styleUrl: './initial-loading.component.scss',
  host: { class: 'ots-app d-flex flex-direction-column', 'aria-busy': 'true' }
})
export class InitialLoadingComponent extends BaseComponent {}
